<div class="popup">
  <h2 i18n="@@ReplaceProduct">Заменить товар {{ requestedImportKey }}</h2>
  <form aria-labelledby="title">
    <div class="mb-3">
      <div class="form-control-group">
        <app-search-autocomplete [mode]="'specification'"></app-search-autocomplete>
      </div>
    </div>
    <div class="mb-3">
      <div class="form-control-group">
        <div class="all-table">
          <ngx-table
                     [configuration]="configuration"
                     [data]="cartProductList"
                     #table
                     [columns]="columns">
          </ngx-table>
        </div>
      </div>
    </div>
    <nb-card-footer>
      <button nbButton
              i18n="@@Send"
              size="large"
              nbSpinnerStatus="control"
              [nbSpinner]="submitted"
              [disabled]="submitted"
              (click)="onSubmit()"
              type="button">
        Добавить
      </button>
      <button type="button" size="large" nbButton i18n="@@Cancel" (click)="close()">
        Отмена
      </button>
    </nb-card-footer>
  </form>

  <ng-template #checkboxTpl let-row let-rowIndex="rowIndex">
    <nb-checkbox
      type="checkbox"
      [checked]="checked"
    />
  </ng-template>

  <ng-template #photoTpl let-row data-th="Фото">
    <div class="responsive-table product-list__photo" i18n-data-th="@@Picture" data-th="Фото">
      <div class="photo-table">
        <div class="photo-table__picture" *ngIf="row.syncUid">
          <a class="mouse-pointer">
            <img alt="" [src]="getImageUri(row.picture)">
          </a>
        </div>

        <div class="photo-table__picture" *ngIf="!row.syncUid">
          <a class="mouse-pointer">
            <img [src]="getImageUri(row.picture)" alt="">
          </a>
        </div>

      </div>
    </div>
  </ng-template>

  <ng-template #headerTpl let-row let-rowIndex="rowIndex">
    <div class="responsive-table" i18n-data-th="@@CodeName" data-th="Артикул / Наименование">
      <div class="name-table">
        <div class="name-table__vendor-code" *ngIf="row.flatCodes">{{ row.flatCodes?.elcom }}</div>
        <div class="name-table__title">
          <p><span class="mouse-pointer">{{ row.header }}</span></p>
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template #availabilityTpl let-row>
    <app-product-availability [product]="row"/>
  </ng-template>

  <ng-template #priceTpl let-row>
    <app-product-price [product]="row"/>
  </ng-template>

  <ng-template #cartTpl let-row>
    <app-specification-add-to-cart [cartProduct]="row"/>
  </ng-template>
</div>
